export const ROLE_CONFIG_VIEWER = 'config-viewer';

export const CONFIG_VIEWER_ROLES = [ROLE_CONFIG_VIEWER];
